import { isWindowDefined } from "@inferno/renderer-shared-core";
import { CopyLinkIcon } from "../icons/CopyLinkIcon.component";

interface CopyLinkButtonProps {
  callback?: () => void;
  children?: React.ReactNode;
}

export const CopyLinkButton = ({ callback, children }: CopyLinkButtonProps) => {
  if (!isWindowDefined()) {
    return null;
  }

  const clickHandler = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    callback?.();
  };

  return (
    <button
      data-platform="copylink"
      className="custom-button copylink-button"
      aria-label="Copy this link"
      onClick={clickHandler}
    >
      <CopyLinkIcon />
      {children}
    </button>
  );
};
